import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, ShieldAlert } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let _cache = null;

// Footer trust line — reads the last recorded security scan / penetration test (AdminX records it after each audit)
export const SecurityBadge = () => {
  const [d, setD] = useState(_cache);
  useEffect(() => {
    if (_cache !== null) return;
    fetch(`${API}/public/security-badge`).then((r) => (r.ok ? r.json() : {})).then((x) => { _cache = x || {}; setD(_cache); }).catch(() => { _cache = {}; });
  }, []);
  if (!d || !d.at || d.status === "unknown") return null;
  const ok = d.status === "passed";
  const stale = d.status === "stale";
  const when = new Date(d.at).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
  return (
    <Link to="/security" data-testid="footer-security-badge" title={d.scope || "Security & penetration testing summary"}
      className={`inline-flex items-center gap-1.5 mt-2 font-mono text-[10px] uppercase tracking-wider border px-2 py-1 transition-colors ${ok ? "border-gf-primary/40 text-gf-primary hover:bg-gf-primary/10" : "border-amber-400/40 text-amber-300 hover:bg-amber-400/10"}`}>
      {ok ? <ShieldCheck className="w-3 h-3" /> : <ShieldAlert className="w-3 h-3" />}
      {ok ? "Security scan passed" : stale ? "Security review due" : "Security review in progress"} · {when}
    </Link>
  );
};
